import axiosInstance from "../api/axiosInstance";

export async function sendOtpFun<T>(apiUrl: string, postData: T) {
  try {
    const token = localStorage.getItem("authToken");
    return await axiosInstance.post(apiUrl, postData, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  } catch (error) {
    console.error("Error sending OTP:", error);
    throw error;
  }
}